import isArray from 'lodash/isArray';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import {
  filterSortCreatedUpdatedName,
} from '../../components/common';

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  col: 12,
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { name: { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search CSV name',
  }],
}];

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  col: 12,
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Find By Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
    // getChoiceLabel: choice => `${(choice.data.name)}`,
  }],
}];

export const filterActionProductsImport = ['FilterField', {
  id: 'action-products-import',
  label: null,
  section: 'top',
  col: 24,
  propsFromPage: props => ({
    client: props.client,
    viewer: props.viewer,
  }),
  // eslint-disable-next-line no-unused-vars
  buildQuery: (value, builder) => {},
  field: ['ActionProductsImport', {
    style: { width: '100%' },
    // getStoreId: props => props.form?.getFieldValue?.('store'),
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  build: builder => builder.add('populate', { store: { name: true } }),
}];

export const filterSelectHidden = ['FilterHidden', {
  id: 'sort',
  build: builder => builder.add('select', {
    name: 1,
    store: 1,
    status: 1,
    limit: 1,
    createdAt: 1,
    updatedAt: 1,
  }),
}];

export const ADMIN = [
  ...[
    [filterSearch, 8],
    [filterStore, 8],
    [filterSortCreatedUpdatedName, 8],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterPagination,
  filterSelectHidden,
  filterPopulateStore,
  filterActionProductsImport,
];

export const SELLER = [
  ...[
    [filterSearch, 12],
    [filterSortCreatedUpdatedName, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterSelectHidden,
  filterPagination,
  filterPopulateStore,
];
